export const environment = {
  production: false,
  userManagementApiUrl: 'https://srv.citex.fund/um',
  policyManagementApiUrl: 'https://srv.citex.fund/pm',
  assetManagementApiUrl: 'https://srv.citex.fund/vm',
  transactionManagementApiUrl: 'https://srv.citex.fund/tm',
  verificationManagementApiUrl: 'https://srv.citex.fund/vrm',
  notificationManagementApiUrl: 'https://srv.citex.fund/nm',
  realtimeUrl: 'wss://srv.citex.fund',
  realtimePath: '/ws',
  // TO REMOVE: Remove this flag when authentication is properly implemented
  addDevHeaders: true,
};
